import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CustomerService } from '../Service';
import { custom } from 'zod';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Loading from '../../../components/Loader/Loading';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import { formatDateTime } from '../../../utils/dateUtils';

const LocationHistory = () => {
    const {id} = useParams();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
        // sortKey: 'createdAt',
        // sortDirection: 'desc',
    });
    const [totalRows, setTotalRows] = useState(0);
    const [locationHistory, setLocationHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const fetchLoationHistory = async()=>{
        setIsLoading(true);
        try {
            const response = await CustomerService.fetchLoactionHistory({
                customerId: id,
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
            });
            if (response.success == '1') {
                setLocationHistory(response.data.addressHistory);
                setTotalRows(response.data.totalCount);
            } else if(response.success == '0'){
                setLocationHistory([]);
                setTotalRows(0);
            }
        } catch (error) {
            console.log("error",error);
        }finally{
            setIsLoading(false);
        }

    }
    useEffect(()=>{
        if (id) {
            fetchLoationHistory();
        }
    },[id,paginationModel]);
    const columns = [
        { field: 'id', headerName: 'SNO.', flex:.25 ,headerAlign:'center',
            renderCell:(params)=>{
                const rowIndex = locationHistory.findIndex(row => row.createdAt === params.row.createdAt);
                const serialNumber = paginationModel.page * paginationModel.pageSize + rowIndex + 1;
                return(
                    <Box sx={{width:'100%',display:'flex',justifyContent:'center'}}>
                        <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#3e3e3e'}}>{serialNumber}</Typography>
                    </Box>
                )
            }
        },
        { field: 'address', headerName: 'Address', flex:2,headerAlign:'center',
            renderCell:(params)=>(
                <Box sx={{width:'100%',display:'flex',justifyContent:'center'}}>
                    <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#3e3e3e'}}>{params.row.address}</Typography>
                </Box>
            )
         },
        { field: 'createdAt', headerName: 'Date', flex:1,headerAlign:'center' ,
            renderCell:(params)=>(
                <Box sx={{width:'100%',display:'flex',justifyContent:'center',p:1}}>
                    <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#3e3e3e'}}>{params.row.createdAt? formatDateTime(params.row.createdAt) : ''}</Typography>
                </Box>
            )
        },
    ]

    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
            ...paginationModel,
            page: newPagination.page,
            pageSize: newPagination.pageSize
        });
    }
  return (
    <Box sx={{p:'1%'}}>
        {/* <Box sx={{borderBottom:'1px solid #d2d2d2',mb:'.5%'}}>
            <Typography sx={{p:'.25% .5%',fontSize:'0.85rem',fontWeight:600,bgcolor:'#d2d2d2',width:'fit-content'}}>Past Location History</Typography>
        </Box> */}
        {/* <Paper sx={{p:'2%'}} >
            <Box sx={{display:'flex',alignItems:'center',mb:'1%',gap:'2%'}}>
                <Typography fontWeight={'600'} sx={{fontSize:'small',color:'#778899'}}>Demo Name</Typography>
            </Box>
            <Typography fontWeight={'500'} sx={{fontSize:'small',textTransform:'capitalize'}}>567, Place, JCF8+3PJ, Nai Basti Dundahera, Ghaziabad, Uttar Pradesh, 201009, India</Typography>
        </Paper> */}
        <DataGrid
            columns={columns}
            rows={locationHistory}
            getRowId={row=>row.createdAt}
            pageSizeOptions={[5,10, 20, 50,(totalRows>50 && totalRows <=100) && totalRows]}

            paginationMode='server'
            rowCount={totalRows}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}           

            loading={isLoading}

            disableColumnMenu
            disableRowSelectionOnClick
            disableColumnFilter
            disableColumnSelector
            // disableSelectionOnClick
            // disableDensitySelector
            slots={{
                toolbar: GridToolbar,                        
                // loadingOverlay: Loading,
                noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
                borderRadius:'0',
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                    borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    p:0,
                    height: 'fit-content',
                    minHeight:'0 !important',
                    height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                borderBottom: 'none',
                '&:first-child': {
                    borderLeft: 'none',
                },
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                    '& .MuiDataGrid-cell:first-child': {
                    borderLeft: 'none',
                },
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
        />
    </Box>
  );
}

export default LocationHistory;
